import { type ListTemplateLayout } from "components/ListTemplate/types";
import React from "react";
import { ExtractorSessionTitle } from "./ExtractorSessionTitle";
import { ExtractorSessionFlightsTableRow } from "./ExtractorSessionFlightsTableRow";

export const cardLayout = (): ListTemplateLayout<server.dto.ExtractorSession> => ({
  type: "card",
  sections: {
    renderTitle: item => <ExtractorSessionTitle item={item} />,
    hideTitle: () => false,
    renderBody: item => <ExtractorSessionFlightsTableRow item={item} />,
    renderFooter: () => null,
    hideFooter: () => true,
  }
});